// Deterministic identicon data generator. Pure function: the same
// (name, variant, seed) always produces the same output, no images, no
// external calls, no randomness. GeneratedAvatar.vue renders this as SVG.
// Generic/reusable — callers own what `variant` means (e.g. a department key)
// and what color the ring is drawn in; this module has no knowledge of either.

function hashString(input) {
  let hash = 0;
  for (let i = 0; i < input.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    hash = (hash * 31 + input.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

function initialsFor(name) {
  const words = (name || '').trim().split(/\s+/).filter(Boolean);
  if (!words.length) return '?';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}

// 8 positions around the avatar ring; each is deterministically on/off from
// the hash so the same identity always renders the same decorative pattern.
const RING_POSITIONS = 8;

export function generateAvatar({ name, variant = '', seed = '' }) {
  const hash = hashString(`${name || ''}|${variant}|${seed}`);
  const ring = Array.from(
    { length: RING_POSITIONS },
    // eslint-disable-next-line no-bitwise
    (_, i) => ((hash >> i) & 1) === 1
  );
  return {
    initials: initialsFor(name),
    hash,
    ring,
  };
}
